// Query key factories for account feature
export const ACCOUNT_QUERY_KEYS = {
  all: ['account'] as const,
  billingPlan: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'billingPlan', cId] as const,
  paymentMethod: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'paymentMethod', cId] as const,
  cardOnFile: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'cardOnFile', cId] as const,
  // One SetupIntent per form open; `attempt` bumps to mint a fresh one after a
  // consumed/expired intent or a failed setup call.
  cardSetup: (cId: number, attempt: number) => [...ACCOUNT_QUERY_KEYS.all, 'cardSetup', cId, attempt] as const,
  invoices: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'invoices', cId] as const,
  team: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'team', cId] as const,
  uploadProfiles: (cId: number) => [...ACCOUNT_QUERY_KEYS.all, 'uploadProfiles', cId] as const,
} as const;

// Note: Sub-accounts and usage derive from customerInfo (authKeys.customerInfo),
// not separate account queries. Don't duplicate those query keys here.

// Billing support contact (legacy app.appCfg.billingEmail)
export const BILLING_EMAIL = 'billing@streamhoster.com';

// CPUser field constraints (verified from legacy validation)
export const CPUSER_CONSTRAINTS = {
  USERNAME_MAX: 40,
  PASSWORD_MIN: 7,
  PASSWORD_MAX: 50,
  FIRST_NAME_MAX: 50,
  LAST_NAME_MAX: 50,
  EMAIL_MAX: 80,
  PHONE_MAX: 20,
} as const;

// Sub-account field constraints
export const SUB_ACCOUNT_CONSTRAINTS = {
  LABEL_MAX: 100,
} as const;

// Upload profile field constraints (verified: label max is 150 from IngestcfgView.validate)
export const UPLOAD_PROFILE_CONSTRAINTS = {
  LABEL_MAX: 150,
} as const;

// Billing form field constraints
export const BILLING_CONSTRAINTS = {
  FULL_NAME_MAX: 50,
  ORG_NAME_MAX: 50,
  ADDRESS_MAX: 60,
  CITY_MAX: 60,
  REGION_MAX: 60,
  POSTAL_CODE_MAX: 20,
  CVV_MAX: 8,
} as const;

// Invoice status labels for badge coloring
export const INVOICE_STATUS_COLORS: Record<string, string> = {
  Paid: 'green',
  Open: 'blue',
  Overdue: 'red',
  Void: 'gray',
} as const;
